/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ gb: NonNullable<unknown> }} Embed_Captions_Pricing_Storage_HelpInputs */

const en_embed_captions_pricing_storage_help = /** @type {(inputs: Embed_Captions_Pricing_Storage_HelpInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.gb} GB • 14 days hosting • Download allowance`)
};

const fr_embed_captions_pricing_storage_help = /** @type {(inputs: Embed_Captions_Pricing_Storage_HelpInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.gb} Go • hebergement 14 jours • allocation de telechargement`)
};

const de_embed_captions_pricing_storage_help = /** @type {(inputs: Embed_Captions_Pricing_Storage_HelpInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.gb} GB • 14 Tage Hosting • Download-Limit`)
};

const it_embed_captions_pricing_storage_help = /** @type {(inputs: Embed_Captions_Pricing_Storage_HelpInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.gb} GB • 14 giorni di hosting • Limite di download`)
};

const ru_embed_captions_pricing_storage_help = /** @type {(inputs: Embed_Captions_Pricing_Storage_HelpInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.gb} ГБ • 14 дней хостинга • Лимит на скачивание`)
};

const es_embed_captions_pricing_storage_help = /** @type {(inputs: Embed_Captions_Pricing_Storage_HelpInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.gb} GB • 14 días de alojamiento • Permiso de descarga`)
};

const zh_cn2_embed_captions_pricing_storage_help = /** @type {(inputs: Embed_Captions_Pricing_Storage_HelpInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.gb} GB • 14 天主机托管 • 下载限额`)
};

const ja_embed_captions_pricing_storage_help = /** @type {(inputs: Embed_Captions_Pricing_Storage_HelpInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.gb} GB • 14日間のホスティング • ダウンロード許容量`)
};

const hi_embed_captions_pricing_storage_help = /** @type {(inputs: Embed_Captions_Pricing_Storage_HelpInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.gb} GB • 14 दिनों की होस्टिंग • डाउनलोड की अनुमति`)
};

const pt_pt2_embed_captions_pricing_storage_help = /** @type {(inputs: Embed_Captions_Pricing_Storage_HelpInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.gb} GB • Hospedagem por 14 dias • Limite de download`)
};

/**
* | output |
* | --- |
* | "{gb} GB • 14 days hosting • Download allowance" |
*
* @param {Embed_Captions_Pricing_Storage_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_pricing_storage_help = /** @type {((inputs: Embed_Captions_Pricing_Storage_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Pricing_Storage_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_embed_captions_pricing_storage_help(inputs)
	if (locale === "de") return de_embed_captions_pricing_storage_help(inputs)
	if (locale === "it") return it_embed_captions_pricing_storage_help(inputs)
	if (locale === "ru") return ru_embed_captions_pricing_storage_help(inputs)
	if (locale === "es") return es_embed_captions_pricing_storage_help(inputs)
	if (locale === "zh-CN") return zh_cn2_embed_captions_pricing_storage_help(inputs)
	if (locale === "ja") return ja_embed_captions_pricing_storage_help(inputs)
	if (locale === "hi") return hi_embed_captions_pricing_storage_help(inputs)
	if (locale === "pt-PT") return pt_pt2_embed_captions_pricing_storage_help(inputs)
	return en_embed_captions_pricing_storage_help(inputs)
});